module.exports = __webpack_public_path__ + "static/media/ring_yellow.272d8f9b.png";